import { ThemeOptions } from '@mui/material';
import { tokens } from './generated/tokens';

export const globalStyles: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      '*': { boxSizing: 'border-box' },
      '.MuiPopover-paper': {
        backgroundColor: tokens.theme.bg.structural.surface,
      },
      body: { margin: 0 },
    },
  },
};
